"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectButton = SelectButton;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function SelectButton(_ref) {
  var active = _ref.active,
      className = _ref.className,
      clearable = _ref.clearable,
      disabled = _ref.disabled,
      fill = _ref.fill,
      handleClear = _ref.handleClear,
      intent = _ref.intent,
      large = _ref.large,
      loading = _ref.loading,
      text = _ref.text,
      props = _objectWithoutProperties(_ref, ["active", "className", "clearable", "disabled", "fill", "handleClear", "intent", "large", "loading", "text"]);

  var classes = (0, _classnames.default)(_defineProperty({}, _index.Classes.ACTIVE, active), _defineProperty({}, _index.Classes.FILL, fill), _defineProperty({}, _index.Classes.intentClass(intent), intent), _defineProperty({}, _index.Classes.LARGE, large), _index.Classes.SELECT_BUTTON, className);
  var placeholder = props.placeholder || 'Please Select';
  var isClearable = clearable && !disabled && handleClear;
  var selectButtonClasses = (0, _classnames.default)(_defineProperty({}, _index.Classes.TEXT_MUTED, !text), _index.Classes.SELECT_BUTTON_TEXT);
  /**
   * Display a caret indicating whether we've got the menu open or not.
   * Replace it with a loading icon if we're loading.
   */

  var icon = /*#__PURE__*/React.createElement(_index.Icon8, {
    icon: active ? _index.IconNames8.CARET_UP : _index.IconNames8.CARET_DOWN
  });
  if (loading) icon = /*#__PURE__*/React.createElement(_index.Spinner, {
    small: true
  });
  /**
   * The button has a data-placeholder attribute so we can refer to it in system tests.
   * We can't put a button within a button so the clearable icon has to be in a span tag.
   */

  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classes,
    disabled: disabled,
    "data-placeholder": placeholder
  }, /*#__PURE__*/React.createElement("span", {
    className: selectButtonClasses
  }, text || placeholder), /*#__PURE__*/React.createElement("span", null, isClearable && /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: '16px'
    }
  }, /*#__PURE__*/React.createElement(_index.IconButton24, {
    icon: _index.IconNames8.CROSS,
    onClick: handleClear,
    tagName: "span",
    "aria-label": "Clear"
  })), icon));
}